// AI_ML.js
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Tabs } from 'antd';
import { useNavigate } from 'react-router-dom';
import Compliance from '../../../components/Compliance';
import ImpactAssessmentForm from '../../../modules/uat/components/ImpactAssessmentForm';
import ImpactAssessmentList from '../../../modules/uat/components/ImpactAssessmentList';
import TestCaseGenerator from './TestCaseGenerator';
import Settings from './Settings';
import { useUser } from '../../../contexts/UserContext';
import { PageHeader } from '../../../components/common';

function AI_ML() {
  const { privileges } = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  // Check if user has SuperAdmin privilege
  const isSuperAdmin = privileges && privileges.some(p => p.privilege_name === 'SuperAdmin');

  // Determine active tab from current path
  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('/test-cases')) return 'test-cases';
    if (path.includes('/compliance')) return 'compliance';
    if (path.includes('/impact-assessment')) return 'impact-assessment';
    if (path.includes('/settings')) return 'settings';
    return 'test-cases';
  };

  // Tab items
  const tabItems = [
    {
      key: 'test-cases',
      label: 'Test Cases',
    },
    {
      key: 'compliance',
      label: 'Compliance',
    },
    {
      key: 'impact-assessment',
      label: 'Impact Assessment',
    },
    ...(isSuperAdmin ? [{
      key: 'settings',
      label: 'Settings',
    }] : []),
  ];

  const handleTabChange = (key) => {
    navigate(`/ai-ml/${key}`);
  };

  return (
    <>
      <PageHeader
        title="AI/ML"
        breadcrumbs={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'AI/ML' }
        ]}
      />

      <Tabs
        activeKey={getActiveTab()}
        items={tabItems}
        onChange={handleTabChange}
        style={{ marginBottom: '24px' }}
      />

      <Routes>
        <Route path="test-cases" element={<TestCaseGenerator />} />
        <Route path="compliance" element={<Compliance />} />
        <Route path="impact-assessment" element={<ImpactAssessmentList />} />
        <Route path="impact-assessment/new" element={<ImpactAssessmentForm />} />
        <Route path="impact-assessment/view/:id" element={<ImpactAssessmentForm />} />
        <Route path="impact-assessment/edit/:id" element={<ImpactAssessmentForm />} />
        {isSuperAdmin && <Route path="settings" element={<Settings />} />}
        <Route path="" element={<Navigate to="test-cases" replace />} />
        <Route path="*" element={<Navigate to="test-cases" replace />} />
      </Routes>
    </>
  );
}

export default AI_ML;